import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
import {SvgIconComponent} from '../../types/utils';

export function createIconComponent(icon: React.FC): SvgIconComponent {
    return React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
        <SvgIcon component={icon} {...props} ref={ref} inheritViewBox={true} />
    )) as unknown as SvgIconComponent;
}
